import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PackAbout from "./PackAbout";
import Header from "../../Shared/Header";
import PackFooter from "../PackFooter";

export class MainAbout extends Component {
  componentDidMount() {
    document.title = "About Us | Jayant Cargo Packers";
  }
  render() {
    return (
      <React.Fragment>
        <Header />
        <section className="__aboutPackBG">
          <Container className="__Head">
            <Row>
              <Col md={12}>
                <h1 className="__AboutHead">About JCP</h1>
              </Col>
            </Row>
          </Container>
        </section>

        <PackAbout />
        <PackFooter />
      </React.Fragment>
    );
  }
}

export default MainAbout;
